/* src/app/system-utils/log-integracao-item/log-integracao-item.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 10px;
  font-family: var(--tem-font-family);
}
.action-bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: var(--tem-radius);
  position: relative;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  padding: var(--tem-space-2) var(--tem-space-3);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
}
.field-button {
  display: flex;
  flex-direction: row;
  gap: 4px;
  white-space: nowrap;
}
.field-filter {
  width: 100%;
}
.field-filter .tem-field {
  width: 100%;
}
.panel-header-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
}
.panel-title {
  font-weight: 600;
  color: var(--tem-ink);
}
.panel-description {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-left: auto;
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm, 12px);
}
.expanse-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  padding: 8px;
  row-gap: 4px;
}
.header {
  font-weight: 600;
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm, 12px);
  padding-left: 10px;
}
.detalhe {
  padding-left: 10px;
  padding-right: 10px;
}
.text-overflow {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.detail-divider {
  margin: 10px 0;
}
.req-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.customtextarea {
  width: 100%;
}
.textarea-inner {
  width: 100%;
  resize: vertical;
}
/*# sourceMappingURL=log-integracao-item.component.css.map */
